<template>
  <div>
    <span @click="onOpen" class="table-link">
      {{ isOrder ? row.orderId : "查看影票信息" }}
    </span>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      modal-append-to-body
      append-to-body
      destroy-on-close
      width="50%"
    >
      <div class="detail" v-loading="detailLoading">
        <template v-if="isOrder">
          <el-row :gutter="24" justify="start">
            <el-col :span="24"><div class="detail-title">基础信息</div></el-col>
            <el-col :span="12">订单ID：{{ detail.orderId }}</el-col>
            <el-col :span="12">用户ID：{{ detail.fansId }}</el-col>

            <el-col :span="12">手机号：{{ detail.reservedPhone }}</el-col>
            <el-col :span="12">创建时间：{{ detail.orderCreateTimeStr }}</el-col>
            <el-col :span="12">订单状态：{{ detail.orderStatusStr }}</el-col>
            <el-col :span="12"
            >拦截状态：{{ detail.interceptOrderStatusStr }}</el-col
            >
            <el-col :span="12"
            >支付金额：<template
              v-if="detail.payAmount !== null || detail.payAmount !== ''"
            >{{ (detail.payAmount / 100).toFixed(2) }}元</template
            ></el-col
            >
            <el-col :span="12">付款时间：{{ detail.payTimeStr }}</el-col>
            <el-col :span="12"
            >购买座位：{{ detail.cinema ? detail.cinema.seat : "" }}</el-col
            >
            <el-col :span="12"
            >是否情侣座：{{ detail.isLove ? "是" : "否" }}</el-col
            >
            <el-col :span="12"
            >是否调座：{{ detail.acceptChangeSeatStr }}</el-col
            >
          </el-row>
        </template>

        <el-row :gutter="24">
          <el-col :span="24"><div class="detail-title">影片信息</div></el-col>
          <el-col :span="24"
          >片名：{{ detail.cinema ? detail.cinema.movieName : "" }}

            <el-image
              v-if="detail.cinema"
              class="detail-img"
              :src="detail.cinema.moviePic"
              :preview-src-list="Array(detail.cinema.moviePic)"
            >
            </el-image>
          </el-col>
          <el-col :span="12"
          >城市：{{ detail.cinema ? detail.cinema.city : "" }}</el-col
          >
          <el-col :span="12"
          >地址：{{ detail.cinema ? detail.cinema.cinemaAddress : "" }}</el-col
          >
          <el-col :span="12"
          >影院：{{ detail.cinema ? detail.cinema.cinemaName : "" }}</el-col
          >
          <el-col :span="12"
          >影厅：{{ detail.cinema ? detail.cinema.hallName : "" }}</el-col
          >

          <el-col :span="12"
          >放映时间:

            {{ detail.cinema ? detail.cinema.showTimeStr : "" }}
          </el-col>
          <el-col :span="12"
          >放映时长:

            <template v-if="detail.cinema"
            >{{ detail.cinema.duration }} 分钟</template
            >
          </el-col>
          <el-col :span="12"
          >语言：

            <template v-if="detail.cinema"
            >{{ detail.cinema.showVersion }}
            </template>
          </el-col>
          <el-col :span="12"
          >市场价：
            <template
              v-if="detail.initPrice !== null || detail.initPrice !== ''"
            >{{ (detail.initPrice / 100).toFixed(2) }}元</template
            >
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="detail.ticketInfo">
          <el-col :span="24"><div class="detail-title">出票信息</div></el-col>
          <el-col :span="12">出票时间：{{ detail.ticketDurationStr }}</el-col>
          <el-col :span="12"
          >是否调座:
            <template>
              {{ detail.ticketInfo.isChangeSeat ? "是" : "否" }}
            </template>
          </el-col>
          <el-col :span="12" v-if="detail.ticketInfo.isChangeSeat"
          >实际座位：{{
              detail.ticketInfo ? detail.ticketInfo.seat : ""
            }}</el-col
          >
          <el-col :span="12"
          >取票码：
            <span v-for="(item, index) in detail.ticketCodeList" :key="index"
            >{{ item.code
              }}{{ detail.ticketCodeList.length > 1 ? "," : "" }}</span
            ></el-col
          >
          <el-col :span="24"
          >取票码截图：
            <template v-if="detail.ticketImgList">
              <el-image
                v-for="(item, index) in detail.ticketImgList"
                :key="index"
                class="detail-img"
                :src="item.url"
                :preview-src-list="Array(item.url)"
              >
              </el-image>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  props: {
    row: {
      type: Object, // 行数据
      default: () => {},
    },
    isOrder: {
      // 是否是订单信息
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detail: {}, // 详情信息
      detailLoading: false, // 详情的loading
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
    };
  },
  computed: {
    title() {
      return this.isOrder ? "订单信息" : "影票信息";
    },
  },
  methods: {
    // 批量操作
    onOpen() {
      this.dialogVisible = true;
      this.getDetail();
    },

    // 请求列表
    async getDetail() {
      this.detailLoading = true;
      const params = {
        orderId: this.row.orderId,
        limit:1
      };
      const res = await MiniModel.getOrderDetail(params).finally(() => {
        this.detailLoading = false;
      });
      if (res.data.code === 200) {
        this.detail = res.data.data || {};
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  .el-col {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 12px;
  }
  &-title {
    font-weight: bold;
    color: #ff8622;
  }
  &-img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-left: 12px;
  }
  &-link {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponGroupNew/component/orderId-detail.vue